import { NgClass } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, DestroyRef, inject, Input, input, OnInit, output, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { Nullable } from 'primeng/ts-helpers';
import { debounce, interval, Subject } from 'rxjs';
import { IconKey } from '../../../../../../../whitelabel/icon-key.enum';
import { IconPipe } from '../../../../../../shared/pipes/icon.pipe';
import { CheckboxComponent } from '../../../../checkbox/checkbox.component';
import { IconFieldComponent } from '../../../icon-field/icon-field.component';
import { InputIconComponent } from '../../../input-icon/input-icon.component';
import { InputTextComponent } from '../../../input-text/input-text.component';

@Component({
  selector: 'osp-select-panel-custom-header',
  standalone: true,
  imports: [
    IconFieldComponent,
    InputTextComponent,
    InputIconComponent,
    CheckboxComponent,
    IconPipe,
    NgClass
  ],
  templateUrl: './select-panel-custom-header.component.html',
  styleUrl: './select-panel-custom-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectPanelCustomHeaderComponent implements OnInit, AfterContentInit {
  private destroyRef = inject(DestroyRef);

  @ViewChild(InputTextComponent, { read: InputTextComponent }) protected filterInput!: InputTextComponent;

  $filterInputAutoFocus = input(true, { alias: 'filterInputAutoFocus' });
  $filterDebounceTime = input(0, { alias: 'filterDebounceTime' });

  $onFilterInput = output<Event>({ alias: 'onFilterInput' });
  $onSelectAll = output<boolean>({ alias: 'onSelectAll' });

  @Input() set filterValue(value: Nullable<string>) {
    this.filterControl.setValue(value, { emitEvent: false });
  }
  @Input() set selectAllValue(value: boolean) {
    this.selectAllControl.setValue(value, { emitEvent: false });
  }

  protected IconKey = IconKey;
  protected filterControl = new FormControl<Nullable<string>>(null);
  protected selectAllControl = new FormControl<boolean>(false);
  protected filterChange$ = new Subject<Event>();

  ngOnInit(): void {
    this.filterChange$
      .pipe(
        debounce(() => interval(this.$filterDebounceTime() ?? 0)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((e: Event) => this.$onFilterInput.emit(e));
  }

  ngAfterContentInit(): void {
    if (this.$filterInputAutoFocus()) {
      setTimeout(() => {
        this.filterInput?.focus();
      })
    }
  }

  resetFilter() {
    this.filterControl.setValue(null);
    this.filterInput?.inputNativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    this.filterInput?.focus();
  }
}
